import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let config = arguments.length > 2 ? arguments[2] : undefined;
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getCidData() {
    return axiosInstance.get('cid-data');
  }

  function createRawCid(_ref) {
    let {
      rawCid,
      sourceId
    } = _ref;
    return axiosInstance.post("cid-tracking/cid/raw", {
      rawCid,
      sourceId
    });
  }

  function getCIDSessionData(id) {
    return axiosInstance.get("cid-persist/" + id);
  }

  function setCIDSessionData(id, cid) {
    return axiosInstance.put("cid-persist/cid", {
      id,
      cid
    });
  }

  return {
    getCidData,
    createRawCid,
    axiosInstance,
    getCIDSessionData,
    setCIDSessionData
  };
}